//This is for POS Print

import React from "react";
import "./stylePos.css";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const PrintBill = React.forwardRef((props, ref) => {
  const { submittedData, pageStatus, invoiceValue } = props;
  const { stockHistories, customer } = submittedData;

  const totalCbm = stockHistories.map((row) => (parseFloat(row.stockHistoryExt?.cbm)))
    .reduce((sum, i) => sum + i, 0);

  const totalCartoon = stockHistories.map((row) => (parseFloat(row.stockHistoryExt?.cartoon)))
    .reduce((sum, i) => sum + i, 0);

  const reTotalCbm = invoiceValue.stockHistories.map((row) => (parseFloat(row.cbm)))
    .reduce((sum, i) => sum + i, 0);

  const reTotalCartoon = invoiceValue.stockHistories.map((row) => (parseFloat(row.cartoon)))
    .reduce((sum, i) => sum + i, 0);
  return (

    <div className ref={ref}>

      <div className="billBody" >
        <BillHeader />
        <div align="center"><strong>{`INVOICE ${pageStatus.recalled ? "Re-Printed" : ""} - ${submittedData.code ?? props.code}`}</strong></div>

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>

        <div >
          <div className="flex" >
            <strong style={{ fontSize: 11 }}> INVOICE: </strong> &nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.code ? submittedData.code : props.invoiceCode}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>CUSTOMER: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}> {customer.firstName}  {customer.shipingCode ? "/ " + customer.shipingCode : ""}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>DATE: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.date}</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>



        <table >
          <thead>
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th>#</th>
              <th style={{ width: 500 }}>DEC</th>
              <th align="center" style={{ paddingLeft: 10 }}>Unit</th>
              <th align="center" style={{ paddingLeft: 10 }}>CTN</th>
              <th align="center" style={{ paddingLeft: 10 }}>CBM</th>
              <th align="center" style={{ paddingLeft: 10 }}>QTY</th>
              <th align="right" style={{ paddingLeft: 10 }}>PRI </th>
              <th align="right" style={{ paddingLeft: 10 }}> D.Rs</th>
              <th align="right" style={{ paddingLeft: 10 }}>AMT</th>
            </tr>
          </thead>
          {pageStatus.adding == true ? (

            <tbody>
              {invoiceValue.stockHistories
                .filter(i => i.quantity > 0)
                .map((row, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td> {index + 1}.</td>
                      <td >{row.itemMaster.name}</td>
                      <td align="center" style={{ paddingLeft: 10 }}>{row.unitName ? row.unitName : row.itemMaster?.itemUnit?.name}</td>
                      <td align="center" style={{ paddingLeft: 10 }}>{row.cartoon}</td>
                      <td align="center" style={{ paddingLeft: 10 }}>{row.cbm}</td>
                      <td align="center" style={{ paddingLeft: 10 }}>{row.quantity}</td>
                      <td align="right" style={{ paddingLeft: 10 }}>{currency(row.retailPrice) }</td>
                      <td align="right" style={{ paddingLeft: 10 }}>{currency(row.discountAmount) }</td>
                      <td align="right" style={{ paddingLeft: 10 }}><strong>{currency((row.quantity * row.retailPrice) - (row.quantity*row.discountAmount))}</strong></td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>


          ) :
            (


              <tbody>
                {stockHistories
                  .filter(i => i.quantity > 0)
                  .map((row, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td> {index + 1}.</td>
                        <td >{row.itemMaster.name}</td>
                        <td align="center" style={{ paddingLeft: 10 }}>{row.unitName ? row.unitName : row.itemMaster?.itemUnit?.name}</td>
                        <td align="center" style={{ paddingLeft: 10 }}>{row.stockHistoryExt?.cartoon}</td>
                        <td align="center" style={{ paddingLeft: 10 }}>{row.stockHistoryExt?.cbm}</td>
                        <td align="center" style={{ paddingLeft: 10 }}>{row.quantity}</td>
                        <td align="right" style={{ paddingLeft: 10 }}>{row.retailPrice}</td>
                        <td align="right" style={{ paddingLeft: 10 }}>{row.discountAmount}</td>
                        <td align="right" style={{ paddingLeft: 10 }}><strong>{currency(row.totalAmount)}</strong></td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>


            )}
        </table>

        <div style={{ borderBottom: "1px solid #000" }}></div>

        <div className="flex-print  mb  justify-content-spaceBetween">
          <div>

            <strong>{COLUMNS_NAME.TOTAL_CARTOON} : </strong>
            <strong>{COLUMNS_NAME.TOTAL_CBM} : </strong>
            <strong>{COLUMNS_NAME.SUB_TOTAL} : </strong>
          </div>

          <div>
            <strong > {totalCartoon ? totalCartoon : reTotalCartoon}</strong>
            <strong > {totalCbm ? totalCbm : reTotalCbm}</strong>
            <strong > {currency(submittedData.subTotalAmount)}</strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween"  >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DISCOUNT_TOTAL}:</strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>{currency(submittedData.discountTotal)}</strong>
          </div>
        </div>
        <div
          className="flex-print  mb  justify-content-spaceBetween"
          style={{ borderTop: "1px solid #000" }}
        >
          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL}</strong>

          <strong style={{ fontSize: 16 }}>{currency(submittedData.totalAmount)}</strong>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.PAYID_AMOUNT} :</strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>{currency(submittedData.paidAmount)}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween" >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.BALANCE_GIVEN} :</strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>
              {`${currency(submittedData.receivedAmount - submittedData.totalAmount)}`}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween" >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.TOTAL_OUTSTANDING} :</strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>
              {`${currency(customer.creditAmount ? customer.creditAmount : 0.00)}`}
            </strong>
          </div>
        </div>


        <div style={{ borderBottom: "1px solid #000" }}></div>

        {/* PRINT WITH BIZX FOOTER */}
        <small className="mt  text-center" >

          <div style={{ fontSize: 11 }} >
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            `{TitumDetails.WEB} | {TitumDetails.EMAIL_ID}`

          </div>
        </small>
      </div>

    </div>
  )
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black